import { Grower } from "../models/grower";

const defaultLabels: Record<string, string> = {
  tasks: "Tasks",
  orders: "Orders",
  cropTracker: "Crop Tracker",
  elements: "Elements",
  seeds: "Seeds",
  crops: "Crops",
  products: "Products",
  customers: "Customers",
  deliveries: "Deliveries",
  diary: "Diary",
  reports: "Reports",
  referrals: "Referrals",
  support: "Support",
  team: "Team",
  settings: "Settings",
  soak: "Soak",
  sow: "Sow",
  blackout: "Blackout",
  uncover: "Uncover",
  harvest: "Harvest",
  package: "Package",
};

export function getCustomLabel(grower: Grower | null, key: string): string {
  if (!grower) {
    return defaultLabels[key] ?? key;
  }

  if (!grower.customLabels) {
    return defaultLabels[key] ?? key;
  }

  try {
    const labels = JSON.parse(grower.customLabels);

    return labels[key] || defaultLabels[key] || key;
  } catch {
    return defaultLabels[key] ?? key;
  }
}
